/// <reference lib="dom" />
export {}; // module scope

const table = document.querySelector(".variant-table");
if (table) {
  const formatters = new Map<string, Intl.NumberFormat>();
  const fmt = (currency: string) => {
    let f = formatters.get(currency);
    if (!f) {
      f = new Intl.NumberFormat("de-DE", { style: "currency", currency });
      formatters.set(currency, f);
    }
    return f;
  };

  const rows = table.querySelectorAll<HTMLTableRowElement>("tbody tr");
  rows.forEach((row) => {
    const priceCell = row.querySelector<HTMLElement>("td[data-island='calculator']");
    const lengthInput = row.querySelector<HTMLInputElement>("input[data-calc-length]");
    const qtyInput = row.querySelector<HTMLInputElement>("input[name='qty']");
    const totalSpan = row.querySelector<HTMLElement>("[data-calc-total]");
    if (!priceCell || !lengthInput || !totalSpan) return;
    const cents = Number(priceCell.dataset.cents);
    const currency = priceCell.dataset.currency || "EUR";
    if (!Number.isFinite(cents)) return;

    const update = () => {
      const meters = Math.max(0, Number(lengthInput.value));
      const bundles = Math.max(1, Number(qtyInput?.value ?? 1) || 1);
      if (!Number.isFinite(meters)) {
        totalSpan.textContent = "";
        return;
      }
      const totalMeters = meters * bundles;
      const total = (cents / 100) * totalMeters;
      const prefix = bundles > 1 ? `${totalMeters} m = ` : "= ";
      totalSpan.textContent = prefix + fmt(currency).format(total);
    };

    lengthInput.addEventListener("input", update);
    qtyInput?.addEventListener("input", update);
    update();
  });
}
